// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  border-radius: 0 !important;
}

.content {
  padding: 1rem;
  margin-bottom: 1rem;
}

.field-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.field-label {
  flex: 0 0 80px;
  margin: 0;
}

.field-value {
  flex: 1 1 auto;
  min-width: 0;
}

.preview-header {
  margin-bottom: 12px;
}
.preview-header p {
  margin: 0;
}

.responsive-table {
  overflow-x: auto;
  margin-bottom: 8px;
}

.preview-table {
  width: 100%;
  font-size: 0.875rem;
}
.preview-table th {
  white-space: nowrap;
  background-color: #f8f9fa;
}
.preview-table .mat-column-select {
  width: 48px;
  padding-right: 0;
}

.empty-state {
  color: #666;
  padding: 16px 0;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/inventory/inventory-dialog/bulk-delete-materials-dialog/bulk-delete-materials-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,SAAA;AACF;;AAEA;EACE,cAAA;EACA,YAAA;AACF;;AAEA;EACE,mBAAA;AACF;AACE;EACE,SAAA;AACJ;;AAGA;EACE,gBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,WAAA;EACA,mBAAA;AAAF;AAEE;EACE,mBAAA;EACA,yBAAA;AAAJ;AAGE;EACE,WAAA;EACA,gBAAA;AADJ;;AAKA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AAFF","sourcesContent":[":host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  border-radius: 0 !important;\n}\n\n.content {\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n.field-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.field-label {\n  flex: 0 0 80px;\n  margin: 0;\n}\n\n.field-value {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.preview-header {\n  margin-bottom: 12px;\n\n  p {\n    margin: 0;\n  }\n}\n\n.responsive-table {\n  overflow-x: auto;\n  margin-bottom: 8px;\n}\n\n.preview-table {\n  width: 100%;\n  font-size: 0.875rem;\n\n  th {\n    white-space: nowrap;\n    background-color: #f8f9fa;\n  }\n\n  .mat-column-select {\n    width: 48px;\n    padding-right: 0;\n  }\n}\n\n.empty-state {\n  color: #666;\n  padding: 16px 0;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
